/*
 * @@Author: MuYang
 */
import {assign, cloneDeep, isBoolean, isUndefined} from 'lodash-es'
import {PRETREATMENT_SUFFIX, PROPS_SUFFIX, LAYOUT_TYPE, HANDLE_SUFFIX} from '../../constants/index'
import {COMPONENTS_NAMES} from '../../constants/componet-names'
import store, {getNodeSchema, insetField, insetMasterRelationPath, insetColumn} from '../store'
import processField from './field'
import { getTargetFlow } from '../global-api/target-stack'
import { createdSubRules } from '../rule'
// import {getI18} from '../../index'

// 匹配全量插槽
function processSlot (slots, reg) {
  const _slot = {}
  for (let key in slots) {
    if (reg.test(key)) {
      _slot[key.replace(reg, '')] = slots[key]
    }
  }
  return _slot
}

const handle = {
  ['field' + PRETREATMENT_SUFFIX]: processField,
  ['viewField' + PRETREATMENT_SUFFIX]: processField,
  ['tabs' + PRETREATMENT_SUFFIX] (node, {config = {}, pageType, objectApiName}) {
    node.objectApiName = objectApiName
    node.elementLinks = node.elementLinks || node.tabs
    node.defaultTab = node.elementLinks.find(tab => tab.defaultSelected) || node.elementLinks[0]
    if (config.tabs) {
      const {change} = config.tabs.event || {}
      node.change = change
      node.propsFn = config.tabs.propsFn
    }
    if (['edit', 'detail'].includes(pageType)) {
      node.info.layoutTabType = 'card'
    }
    return node
  },
  ['tabItem' + PRETREATMENT_SUFFIX] (node, {objectApiName, _id, config = {}}) {
    if (node.info.info) {
      node.info = node.info.info
      if (node.info?.i18nMap?.['form_tab_name']) {
        node.info.i18nMap['list_tab_name'] = node.info.i18nMap['form_tab_name']
      }
    }
    node.viewContent = node.layout?.elementLinks || getNodeSchema(_id, objectApiName, node.info.apiName)
    node.apiName = `tab-item_${node.info.apiName}`
    if (config.tabs) {
      const {data = {}} = config.tabs.props || {}
      assign(node.info, data[node.info.apiName])
      node.slots = config.tabs.slots?.[node.info.apiName] || {}
    }
    return node
  },
  ['masterRelation' + PRETREATMENT_SUFFIX] (node, {objectApiName, subPages, _id}, parentPath) {
    if (subPages) {
      assign(node, subPages.find(item => item.layoutSeqCode === node.targetSeqCode))
    }
    node.__is = true
    node.isMasterRelation = true
    node.apiName = node.subObjectParamName || node.targetObjectSeqCode
    insetMasterRelationPath(_id, node.objectApiName, parentPath)
    insetField(_id, node, objectApiName, node.apiName)
    node.viewContent = node.layout?.elementLinks || getNodeSchema(_id, objectApiName, node.layoutSeqCode)
    node.rules = store.cache[_id].rulesMap
    return node
  },
  ['polymericList' + PRETREATMENT_SUFFIX] (node, { objectApiName, _id, subPages }, parentPath) {
    if (subPages) {
      assign(node, subPages.find(item => item.objectSeqCode === node.targetObjectSeqCode))
    }
    node.__is = true
    node.isMasterRelation = true
    node.apiName = node.layoutApiName
    // node.apiName = node.targetSeqCode || node.targetObjectSeqCode
    node.objectApiName = node.layoutApiName
    // node.targetObjectApiName = node.layoutApiName
    insetMasterRelationPath(_id, node.objectApiName, parentPath)
    insetField(_id, node, objectApiName, node.apiName)
    node.viewContent = node.layout?.elementLinks || getNodeSchema(_id, objectApiName, node.targetSeqCode)
    node.rule = createdSubRules({fromObjectRequired: true, verificationTips: '数据列表不能为空'})
    return node
  },
  ['cards' + PRETREATMENT_SUFFIX] (node, payload) {
    const {objectApiName, config = {}, _id, integrationConfig} = payload
    node.expansion = getNodeSchema(_id, objectApiName, 'expansion')
    assign(node, config.card?.event, config.card?.props)
    const _field = config.card?.column || {}
    node.viewContent.forEach(field => {
      assign(field, _field[field.targetApiName], _field[field.targetApiName]?.props)
    })

    if (config.card) {
      node.slots = config.card.slots || {}
    }
    const {grouping, integrationGroups} = integrationConfig
    if (grouping) {
      if (integrationGroups.length > 0) {
        node.LineGroup = true
        integrationGroups.forEach(group => {
          group.elementLinks.forEach(element => {
            handle[['field' + PRETREATMENT_SUFFIX]](element, payload)
          })
          if (group.targetType === 'field_group_type_row_group_left') {
            node.integrationGroupLeft = group.elementLinks
          } else {
            node.integrationGroupRight =  group.elementLinks
          }
        })
        node.integrationGroups = integrationGroups
      }
    }
    return node
  },
  ['table' + PRETREATMENT_SUFFIX] (node, payload) {
    const {objectApiName, layoutApiName, config = {}, buttonMap = {}, pageType, integrationConfig, subObjectParamName} = payload
    node.objectApiName = objectApiName
    node.pageType = pageType
    node.layoutApiName = layoutApiName
    node.inlineButtons = buttonMap['section_inline'] || []
    node.viewContent.forEach(column => {
      column.targetType = 'column'
    })
    // 从对象跨页勾选
    if (subObjectParamName) {
      node.reserveSelection = true
    }
    if (config.table) {
      const {showSelection} = config.table.props || {}
      node.selectType = 'checkbox'
      node.showSelection = showSelection
      assign(node, config.table.event, config.table.props)
      const _column = config.table.column || {}
      node.viewContent.forEach(column => {
        assign(column, _column[column.info.apiName], _column[column.info.apiName]?.props)
      })
      node.slots = config.table.slots || {}
    }
    const {grouping, integrationGroups = [], mode, groupMaxHeight} = integrationConfig
    if (grouping) {
      integrationGroups.forEach(group => {
        group.elementLinks.forEach(element => {
          handle[['field' + PRETREATMENT_SUFFIX]](element, payload)
        })
        if (group.targetType === 'field_group_type_row_group_left') {
          node.integrationGroupLeft = group.elementLinks
        } else {
          node.integrationGroupRight =  group.elementLinks
        }
      })
      node.integrationConfig = {
        tableComponentName: mode,
        integrationGroups: integrationGroups[0]?.elementLinks,
        grouping,
        groupMaxHeight
      }
    }
    
    return node
  },
  ['filter' + PRETREATMENT_SUFFIX] (node, {scopedSlots}) {
    node.scopedSlots = processSlot(scopedSlots, /^search_item_/)
    return node
  },
  ['group' + PRETREATMENT_SUFFIX] (node, payload) {
    const {config = {}} = payload
    node._isDel = (node.viewContent.length === 0) && (node.__targetType === 'fieldGroup_type_normalGroup')
    node.slots = {}
    if (!node.props) {
      node.props = {}
    }
    if (config.group) {
      assign(node, config.group[node.info.apiName])
    }
    node.props.fold = node.info.folded
    if (node.__path.includes('tabs')) {
      node.props.shadow = false
      node.props.borderStyle = {
        'border': 'none'
      }
    }
    if (!isBoolean(node.props.hideHeader)) {
      node.props.hideHeader = node.info.hiddenStyle
    }
    if (LAYOUT_TYPE.TARGET_TYPE_SUMMARY === getTargetFlow()) {
      let headerField = null
      node.viewContent = node.viewContent.filter(v => {
        if (v.fieldConf?.section === 'main') {
          headerField = v
          return false
        }
        return true
      })
      if (headerField) {
        node.headerField = cloneDeep(processField(headerField, payload))
        // fix:摘要区内主信息字段没有走自定义的schemaHandle 导致props状态不对
        const nodeConfig = store.handle[node.headerField.targetType + HANDLE_SUFFIX]
        if (nodeConfig?.handle) {
          assign(node.headerField, nodeConfig.handle(node.headerField, payload))
        }
        if (!node.headerField.fieldConf) {
          node.headerField.fieldConf = {}
        }
        node.headerField.fieldConf.supportBanner = 1
        node.headerField.propsFn = null
        node.headerField.props.pageShow = true
        node.headerField.props.isPureText = true
        node.props.fold = false
      }
    }
    node.info.name = payload?.i18Maps[node?.info?.i18nMap?.['page_group_name']] || node.info.name
    return node
  },
  ['column' + PRETREATMENT_SUFFIX] (node, payload) {
    const {info} = node
    const {objectApiName, _id} = payload
    insetColumn(_id, node, objectApiName, info.apiName)
    info.name = payload?.i18Maps[info?.i18nMap?.['page_group_name']] || info.name
    // console.log(node, '====node======node==')
    return node
  },
  ['fieldGroup' + PRETREATMENT_SUFFIX] (node, payload, parentPath) {
    node.type = 'fieldGroup'
    node.name = payload?.i18Maps[node.info?.i18nMap?.['field_group_name']] || node.info.name 
    node.pageType = payload.pageType
    const result = handle.fieldPretreatment(node, payload, parentPath)
    result.viewComponentName = 'field-group-render'
    // console.log(node.elementLinks, '==--3')
    result.viewContent = node.elementLinks
    result.viewContent.forEach((item) => {
      item.showTooltip = false
    })
    // node.viewContent
    return result
  },
  ['staticArea' + PRETREATMENT_SUFFIX] (node, payload) {
    node.name = payload?.i18Maps[node?.i18nMap?.['static_area_title_name']] || node.name
    node.content = payload?.i18Maps[node?.i18nMap?.['static_area_content']] || node.content
    assign(node, payload?.config?.staticArea?.[node.apiName])
    return node
  },
  ['footer' + PRETREATMENT_SUFFIX] (node) {
    return node.info
  }
}

// 公共预处理方法
export function pretreatment (node, paylodStore, parentPath) {
  if (node.__is) {
    return node
  }
  let cell = node
  cell.__path = parentPath
  cell.viewComponentName = COMPONENTS_NAMES[node.targetType] || node.targetType
  cell.viewContent = node.viewContent || node.elementLinks
  // 处理apiName 添加唯一key
  cell.apiName = node.apiName || node.targetType
  // cell.info = node.info
  cell._type = node._type || node.targetType
  // 自定义预先处理参数
  const _pretreatment = handle[node.targetType + PRETREATMENT_SUFFIX]

  if (_pretreatment) {
    assign(cell, _pretreatment(cell, paylodStore, parentPath))
  }
  // 格式化 props
  if (cell.__targetType !== 'field' && cell.__targetType !== 'viewField') {
    _initProps(cell)
  }
  cell.__path = (parentPath ? parentPath + '/' : '') + cell.apiName
  delete cell.elementLinks
  
  return cell
}

export function _initProps (cell, targetType) {
  const _props = store.componentsProps[(targetType || cell.targetType) + PROPS_SUFFIX]
  if (!isUndefined(_props)) {
    if (!cell.props) {
      cell.props = {}
    }
    for (const key in _props) {
      if (!(key in cell.props) || isUndefined(cell.props[key])) {
        cell.props[key] = isUndefined(cell[key]) ?  cell.info?.[key] : cell[key]
      }
    }
  }
}

export default pretreatment
